import { EmployeeUpload } from './pages/EmployeeUpload';

export function ImportsPage() {
	return (
		<div>
			<EmployeeUpload />
		</div>
	);
}
